import { Modal, Spin } from 'antd';
import React, { FC } from 'react';
import './styles.scss';
import { Button } from '@ui-modules';

interface IProps {
  isConfirmationVisible: boolean;
  setIsConfirmationVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmitHandler: () => void;
  isButtonDisabled: boolean;
}

const ConfirmationModal: FC<IProps> = ({
  isConfirmationVisible,
  setIsConfirmationVisible,
  onSubmitHandler,
  isButtonDisabled,
}) => {
  return (
    <Modal
      footer={null}
      title={
        <div className="modal-title">
          <p>Save freight assignments</p>
        </div>
      }
      width="60%"
      centered
      visible={isConfirmationVisible}
      onCancel={() => setIsConfirmationVisible(false)}
    >
      <p className="modal-info">
        Emails notification are currently disabled, the assignment will be saved but no email will
        be sent to select and unselected providers
      </p>
      <Spin spinning={isButtonDisabled} className="confirmation-loader" />
      <div className={`button-container ${isButtonDisabled && 'hidden'}`}>
        <Button onClick={() => setIsConfirmationVisible(false)} variant="danger" text="CANCEL" />
        <Button
          disabled={isButtonDisabled}
          onClick={onSubmitHandler}
          variant="submit"
          text="CONFIRM"
        />
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
